import React from "react";
import ExperienceCard from "../../components/cards/ExperienceCard";

function ExperienceSnapshotSection() {
  const experiences = [
    {
      role: "Lead Software Engineer",

      company: "PT. Berkah Angsana Teknika",

      period: "Oct 2024 - Present",

      status: "Current",

      responsibilities: [
        "Lead the development of production-grade web applications including attendance, payroll, and operational management systems.",
        "Designed backend architecture, REST APIs, PostgreSQL databases, and managed deployment, maintenance, and engineering workflows.",
      ],
    },

    {
      role: "AI / Machine Learning Engineer",

      company: "PT. Meister Sinergi Indonesia",

      period: "Oct 2023 - Sep 2024",

      status: "Artificial Intelligence",

      responsibilities: [
        "Developed and integrated AI models for real-time CCTV analysis and computer vision applications.",
        "Prepared machine learning datasets and collaborated with engineering teams to deploy AI solutions into production environments.",
      ],
    },

    {
      role: "Fullstack Developer",

      company: "PT. Jasamedika Saranatama",

      period: "May 2022 - Aug 2023",

      status: "Healthcare Systems",

      responsibilities: [
        "Developed Executive Information Systems (EIS) for healthcare institutions using React and Python-based REST APIs.",
        "Built data visualization dashboards and collaborated with cross-functional teams to deliver scalable reporting solutions.",
      ],
    },

    {
      role: "Freelance Fullstack Developer",

      company: "Independent Projects",

      period: "2023 - Present",

      status: "Production Projects",

      responsibilities: [
        "Built scalable software solutions including the Syndrome UKAI learning platform and IoT-based energy monitoring systems.",
        "Designed RESTful APIs, data processing pipelines, and managed deployment and maintenance for multiple production applications.",
      ],
    },
  ];

  return (
    <section
      id="experience"
      className="bg-transparent p-4 sm:p-8 font-sans border-t border-slate-900/10 mt-12"
    >
      <div className="mx-auto max-w-5xl w-full">
        {/* Section Header */}
        <div className="mb-12 text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-gsf-bronze">
            Professional Experience
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mt-1 tracking-tight">
            Building Production Software
          </h2>
          <p className="text-sm text-slate-600 font-medium mt-2 max-w-md mx-auto">
            A snapshot of my professional journey building scalable software,
            enterprise applications, AI solutions, and production systems across
            multiple industries.
          </p>
        </div>

        {/* Stacked Step-Down Layout with Neo-Brutalisme Arrows */}
        <div className="space-y-4">
          {experiences.map((exp, index) => (
            <React.Fragment key={index}>
              {/* Render Experience Card */}
              <ExperienceCard
                role={exp.role}
                company={exp.company}
                period={exp.period}
                status={exp.status}
                responsibilities={exp.responsibilities}
              />

              {/* Tampilkan Elemen Panah Alur Ke Bawah jika bukan elemen terakhir */}
              {index < experiences.length - 1 && (
                <div className="flex justify-center py-2 select-none">
                  <div className="w-10 h-10 border-2 border-slate-900 bg-white rounded-full flex items-center justify-center font-black text-slate-900 text-lg shadow-[2px_2px_0px_0px_#ccd5ae] transform transition-transform duration-200 hover:scale-110">
                    ↓
                  </div>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ExperienceSnapshotSection;
